export default __webpack_public_path__ + "static/half-scattered-images-e41d467651fe182564e1fa29891504dd.svg";